import React, {
  useState,
  useEffect,
  Dispatch,
  SetStateAction,
  FC,
  memo,
} from 'react';
import DatePicker from 'react-datepicker';
import { IEvents } from 'types';
import _ from 'lodash';
import moment, { Moment } from 'moment';
import CustomButton from 'components/common/customButton/customButton';
import plus from 'style/imgs/icons/plus.svg';
import arrow from 'style/imgs/icons/arrow.svg';
import calendar from 'style/imgs/icons/Calendar.svg';
import MobileService from 'services/mobile';
import Switcher from '../switcher/customSwitcher';
import Modal from './modal';
import styles from './index.module.scss';

interface IHeaderProps {
  searcIndex: (inputArray: Moment[][], searchValue: string) => number[] | null;
  handleChangeWeek: (week: number) => void;
  addEvent?: (data: IEvents, unitId: number) => void;
  setDaysToShow: (days: number) => void;
  days: Moment[][];
  isWeekly: boolean;
  setIsWeekly: Dispatch<SetStateAction<boolean>>;
  currentMoment: Moment;
  setLastDay: Dispatch<SetStateAction<Moment>>;
  setStartDay: Dispatch<SetStateAction<Moment>>;
  setSelectedDate?: Dispatch<SetStateAction<Date>>;
  week: number;
  date: Moment[];
  lastDay: Moment;
  startDay: Moment;
}

const CustomSelect: FC<IHeaderProps> = ({
  handleChangeWeek,
  week,
  addEvent,
  setDaysToShow,
  setSelectedDate,
  searcIndex,
  setLastDay,
  setStartDay,
  setIsWeekly,
  isWeekly,
  lastDay,
  startDay,
  date,
  days,
}) => {
  const [displayDate, setDisplayDate] = useState('');
  const [selectDate, setSelectDate] = useState(moment().toDate());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const setCalendarDaysCount = (isActive: boolean) => {
    if (isActive) {
      setDaysToShow(7);
    } else {
      setDaysToShow(1);
    }
    setIsWeekly(isActive);
  };

  useEffect(() => {
    if (days && !_.isEmpty(days) && searcIndex) {
      const currentWeek = searcIndex(
        days,
        moment(selectDate).format('YYYY-MM-DD')
      );
      if (currentWeek) {
        handleChangeWeek(currentWeek[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectDate, days]);

  const handleChangeCalendarDay = (d: Date) => {
    if (days && !_.isEmpty(days) && searcIndex && isCalendarOpen) {
      const lastDayInArray: moment.Moment | undefined = _.last(_.last(days));
      const dayIndex = searcIndex(days, moment(d).format('YYYY-MM-DD'));

      if (dayIndex && week !== dayIndex[0]) {
        handleChangeWeek(dayIndex[0]);
      }
      const diff = moment(d).diff(moment(lastDayInArray), 'months');
      if (dayIndex === null) {
        if (diff > 0) {
          setLastDay(lastDay.clone().add(diff + 1, 'month'));
        } else {
          setStartDay(startDay.clone().subtract(diff * -1, 'month'));
        }
      }
    }
    setSelectDate(d);
    if (setSelectedDate) {
      setSelectedDate(d);
    }
  };

  useEffect(() => {
    if (setSelectedDate) {
      setSelectedDate(moment(date && date[0]).toDate());
    }
    if (isWeekly) {
      setDisplayDate(
        `${moment(date && date[0]).format('MMM D')}-${moment(
          date && date[6]
        ).format('D, YYYY')}`
      );
    } else {
      setDisplayDate(
        `${moment(date && date[0]).format('ddd, MMMM DD, YYYY')} `
      );
    }
  }, [isWeekly, date, setSelectedDate]);

  const handleNext = () => {
    if (week < days.length - 1) {
      handleChangeWeek(week + 1);
    }
    if (days.length - 1 === week) {
      setLastDay(lastDay.clone().add(1, 'month'));
    }
  };

  const handlePrev = () => {
    if (week >= 1) {
      handleChangeWeek(week - 1);
    }
    if (week === 0) {
      setStartDay(startDay?.clone().subtract(1, 'month'));
    }
  };

  return (
    <div
      className={`${styles.header} ${
        MobileService.isMobile ? styles.tablet : ''
      }`}
    >
      {addEvent && (
        <div>
          <Modal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            addEvent={addEvent}
            time={moment().format('LT')}
            trigger={
              <CustomButton color="mint" text="Add activity" icon={plus} />
            }
          />
        </div>
      )}
      <div
        className={`${styles.switchDaysButtons} ${
          MobileService.isMobile ? styles.tablet : ''
        }`}
      >
        <button
          onClick={handlePrev}
          type="button"
          className={styles.buttonNext}
        >
          <img src={arrow} alt="prev" />
        </button>
        <DatePicker
          selected={selectDate}
          onChange={handleChangeCalendarDay}
          disabledKeyboardNavigation
          dateFormat="d MMM, yyyy"
          onCalendarClose={() => setIsCalendarOpen(false)}
          onCalendarOpen={() => setIsCalendarOpen(true)}
          customInput={
            <CustomButton color="orange" text={displayDate} icon={calendar} />
          }
        />
        <button
          onClick={handleNext}
          type="button"
          className={styles.buttonNext}
        >
          <img src={arrow} alt="next" />
        </button>
      </div>
      <Switcher
        onChange={setCalendarDaysCount}
        checked={isWeekly}
        offName="Day"
        onName="Week"
      />
    </div>
  );
};

export default memo(CustomSelect);
